






























































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { mdbBtn, mdbIcon, mdbTooltip, mdbProgress, mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody, mdbModalFooter, mdbPopover } from '@folky-tools/mdbvue';
import { Reference } from '@/models/references/reference';
import { BusinessSellingOptions } from '@/models/businesses/business-selling-options';
import Swal from 'sweetalert2';
import { VueGoodTable } from '@folky-tools/vue-good-table';
import { UserActionLogInfo } from '@/models/users/user-logging/user-action-log-info';
import { UserActionType } from '@/models/users/user-logging/user-action-type';
import { UserActionEntityType } from '@/models/users/user-logging/user-action-entity-type';
import { UserActionScopeType } from '@/models/users/user-logging/user-action-scope-type';
import {
    usersService,
    axiosService,
    referencesService,
    businessFrontPagesService,
    getOrganizationBusinessPricingsFromMainProject,
    businessSellingOptionsService,
    authorizationManagerService,
    notificationsService,
    localStorageService,
    cloneOrganizationReference,
    CloneOrganizationReferenceInputDto
} from '@/services';

@Component({
    components: {
        mdbBtn,
        mdbIcon,
        mdbTooltip,
        mdbProgress,
        mdbModal,
        mdbModalHeader,
        mdbModalTitle,
        mdbModalBody,
        mdbModalFooter,
        mdbPopover,
        VueGoodTable,
        NewReference: () => import('@/components/references/NewReference.vue'),
        ReferenceStockLevels: () => import('@/components/references/ReferenceStockLevels.vue'),
        FormModal: () => import('@/components/shared/FormModal.vue'),
        AppSysBar: () => import('@/components/shared/AppSysBar.vue')
    }
})
export default class ReferencesListView extends Vue {
    private actualUserCanCreateReferences: boolean = false;
    private rows: any[] = [];
    private columns: any[] = [];
    private totalRecords: number = 0;
    private isLoading: boolean = false;
    private initialPage: number = 1;
    private initialRefsPerPage: number = 20;
    private initialSortBy: any = {};
    private showEditStockLevels: boolean = false;
    private savingStockLevels: boolean = false;
    private selectedReference: Reference = new Reference();
    private rowsCopy: any[] = [];
    private serverParams: any = {};

    private singleEditBusinessId: number | null = null;
    private singleEditBusinessPricingLevel: number | null = null;
    private singleEditBusinessSellingOptions: BusinessSellingOptions = new BusinessSellingOptions();

    private async beforeMount(): Promise<void> {
        if (authorizationManagerService.canWriteOnlySingleBusiness) {
            this.singleEditBusinessId = authorizationManagerService.authorizedBusinessIdsToEdit[0];
            const singleEditBusinessPricings: any = await getOrganizationBusinessPricingsFromMainProject.execute(this.singleEditBusinessId);
            this.singleEditBusinessPricingLevel = singleEditBusinessPricings.find((p: any) => p.isBusinessSubscribedTo).level;
            this.singleEditBusinessSellingOptions = await businessSellingOptionsService.getSellingOptions(this.singleEditBusinessId);
        }

        this.setColumns();
        this.initServerParams();
        this.initPaging();
        await this.loadItems();
    }

    private async mounted(): Promise<void> {
        this.actualUserCanCreateReferences = authorizationManagerService.canCreateReferences;

        if (this.$route.query.businessName) {
            this.$root.$emit('change-active-page', 'views.references.referencesListView.titleSingleBusiness', this.$route.query.businessName.toString());
        } else {
            this.$root.$emit('change-active-page', 'views.references.referencesListView.title');
        }

        await usersService.logUserAction(
            new UserActionLogInfo({
                type: UserActionType.HasVisited,
                entity: UserActionEntityType.Products,
                scope: UserActionScopeType.List
            })
        );
    }

    private initServerParams() {
        const savedFilters = localStorageService.getReferencesListFilters();
        if (savedFilters) {
            this.serverParams = savedFilters;
        } else {
            this.serverParams = {
                columnFilters: {
                    displayTitle: '',
                    categoryName: '',
                    businessTradeName: ''
                },
                sort: [
                    {
                        field: 'id',
                        type: 'desc'
                    }
                ],
                page: this.initialPage,
                perPage: this.initialRefsPerPage
            };
        }
    }

    private async onPageChange(params: any): Promise<void> {
        this.serverParams.page = params.currentPage;
        await this.loadItems();
    }

    private async onPerPageChange(params: any): Promise<void> {
        this.serverParams.perPage = params.currentPerPage;
        await this.loadItems();
    }

    private async onSortChange(params: any): Promise<void> {
        if (params[0].field !== this.serverParams.sort[0].field || params[0].type !== this.serverParams.sort[0].type) {
            this.serverParams.sort[0].field = params[0].field === 'displayTitle' ? 'title' : params[0].field;
            this.serverParams.sort[0].type = params[0].type;
            await this.loadItems();
        }
    }

    private async onColumnFilter(params: any): Promise<void> {
        const columnFiltersChanged = await this.columnFiltersChanged(params.columnFilters);
        if (columnFiltersChanged) {
            this.serverParams.page = 1;
            this.serverParams.columnFilters = JSON.parse(JSON.stringify(params.columnFilters));
            await this.loadItems();
        }
    }

    private async loadItems(): Promise<void> {
        this.isLoading = true;

        const response: any = await axiosService.instance.get('references/organization/Product/query', {
            params: await this.getQueryParams(this.serverParams.sort, this.serverParams.page, this.serverParams.perPage)
        });

        this.rows = [];

        this.totalRecords = response.data.count;
        response.data.items.forEach((item: any) => {
            this.rows.push(new Reference(item));
        });

        this.isLoading = false;
    }

    private async getQueryParams(sortOrder: any, currentPage: number, perPage: number): Promise<any> {
        return {
            $skip: (currentPage - 1) * perPage,
            $top: perPage,
            $orderby: this.getQueryOrderFromColumn(sortOrder),
            $filter: await this.getQueryFilterFromColumns()
        };
    }

    private getQueryOrderFromColumn(sortOrder: any): string | null {
        if (sortOrder && sortOrder.length === 1) {
            if (sortOrder[0].field === 'created') {
                return `createdUtc ${sortOrder[0].type}`;
            } else {
                return `${sortOrder[0].field} ${sortOrder[0].type}`;
            }
        } else {
            return null;
        }
    }

    private async getQueryFilterFromColumns(): Promise<string | null> {
        let queryFilter = '';
        const logicalOperatorBetweenFilters = ' and ';

        for (const key of Object.keys(this.serverParams.columnFilters)) {
            if (this.serverParams.columnFilters[key]) {
                if (key === 'displayTitle') {
                    queryFilter += `${logicalOperatorBetweenFilters}contains(title, '${this.serverParams.columnFilters[key].replace('\'', '\'\'')}')`;
                }
                if (key === 'businessTradeName') {
                    queryFilter += `${logicalOperatorBetweenFilters}contains(businessTradeName, '${this.serverParams.columnFilters[key].replace('\'', '\'\'')}')`;
                }
                if (key === 'categoryName') {
                    queryFilter += `${logicalOperatorBetweenFilters}contains(categoryName, '${this.serverParams.columnFilters[key].replace('\'', '\'\'')}')`;
                }
            }
        }

        return queryFilter === '' ? null : queryFilter.substring(logicalOperatorBetweenFilters.length);
    }

    private setColumns(): void {
        const savedFilters = localStorageService.getReferencesListFilters();

        this.columns = [
            {
                field: 'id',
                type: 'number',
                sortable: true
            },
            {
                field: 'displayTitle',
                sortable: true,
                filterOptions: {
                    enabled: true,
                    placeholder: this.$t('common.placeholders.searchByName'),
                    filterValue: savedFilters ? savedFilters.columnFilters['displayTitle'] : ''
                }
            },
            { field: 'stockLevels', sortable: false, type: 'number' },
            {
                field: 'formattedPrincipalSkuPrice',
                sortable: false,
                type: 'number'
            },
            {
                field: 'categoryName',
                sortable: false,
                filterOptions: {
                    enabled: true,
                    placeholder: this.$t('common.placeholders.searchByCategory'),
                    filterValue: savedFilters ? savedFilters.columnFilters['categoryName'] : ''
                }
            }
        ];

        if (authorizationManagerService.isAdmin || authorizationManagerService.canReadMultipleBusinesses) {
            this.columns.push({
                field: 'businessTradeName',
                sortable: false,
                filterOptions: {
                    enabled: true,
                    placeholder: this.$t('common.placeholders.searchBySeller'),
                    filterValue: savedFilters ? savedFilters.columnFilters['businessTradeName'] : ''
                }
            });
        }

        if (authorizationManagerService.isAdmin) {
            this.columns.push({ field: 'created', sortable: true });
        }

        this.columns.push({ field: 'isPublishedInAConsumer', sortable: true });
        if (!this.singleEditBusinessId || (this.singleEditBusinessId && this.singleEditBusinessPricingLevel && this.singleEditBusinessPricingLevel > 3)) {
            this.columns.push({ field: 'available', sortable: true });
        }
        if (!this.singleEditBusinessId || (this.singleEditBusinessSellingOptions && this.singleEditBusinessSellingOptions.allowSale && this.singleEditBusinessSellingOptions.salesAdmissionHoursSchedule)) {
            this.columns.push({ field: 'isTimeSensitive', sortable: true });
        }
        this.columns.push({ field: 'actions-slot', sortable: false });
    }

    private async unpublishReference(id: number, refName: string): Promise<void> {
        const questionResult = await Swal.fire({
            title: this.$i18n.t('views.references.referencesListView.actions.unpublish.modal.title').toString(),
            html: '<h3>' + refName + '</h3>' + this.$i18n.t('views.references.referencesListView.actions.unpublish.modal.textHtml').toString() + this.$i18n.t('common.warning.changesInWebTakeTime').toString(),
            type: 'warning',
            showCancelButton: true,
            reverseButtons: true,
            focusConfirm: false,
            focusCancel: true,
            confirmButtonText: this.$i18n.t('views.references.referencesListView.actions.unpublish.modal.confirm.doConfirm').toString(),
            cancelButtonText: this.$i18n.t('views.references.referencesListView.actions.unpublish.modal.doCancel').toString(),
            customClass: {
                confirmButton: 'btn btn-primary',
                cancelButton: 'btn btn-danger'
            },
            animation: false
        });

        if (questionResult.value) {
            this.isLoading = true;
            if (await referencesService.unpublishReference(id)) {
                this.isLoading = false;
                notificationsService.showToastSuccessNotification('views.references.referencesListView.actions.unpublish.modal.confirm.successMessage');
                await this.loadItems();

                await usersService.logUserAction(
                    new UserActionLogInfo({
                        type: UserActionType.HasChanged,
                        entity: UserActionEntityType.Products,
                        scope: UserActionScopeType.Publication,
                        entityId: id
                    })
                );

                return;
            }
            this.isLoading = false;
            notificationsService.showToastErrorNotification();
        }
    }

    private async publishReference(businessId: number, id: number, refName: string): Promise<void> {
        if (businessId && !(await businessFrontPagesService.isPublishedBusinessFrontPage(businessId, true))) {
            notificationsService.showToastWarningNotification('views.references.referencesListView.actions.publish.notifications.publishParentToPublishReference');
            return;
        }

        const questionResult = await Swal.fire({
            title: this.$i18n.t('views.references.referencesListView.actions.publish.modal.title').toString(),
            html: '<h3>' + refName + '</h3>' + this.$i18n.t('views.references.referencesListView.actions.publish.modal.textHtml').toString() + this.$i18n.t('common.warning.changesInWebTakeTime').toString(),
            type: 'warning',
            showCancelButton: true,
            reverseButtons: true,
            focusConfirm: true,
            focusCancel: false,
            confirmButtonText: this.$i18n.t('views.references.referencesListView.actions.publish.modal.doConfirm').toString(),
            cancelButtonText: this.$i18n.t('views.references.referencesListView.actions.publish.modal.doCancel').toString(),
            customClass: {
                confirmButton: 'btn btn-primary',
                cancelButton: 'btn btn-danger'
            },
            animation: false
        });

        if (questionResult.value) {
            this.isLoading = true;
            if (await referencesService.publishReference(id)) {
                this.isLoading = false;
                notificationsService.showToastSuccessNotification('views.references.editReferenceView.notifications.publishRefSuccess');
                await this.loadItems();

                await usersService.logUserAction(
                    new UserActionLogInfo({
                        type: UserActionType.HasChanged,
                        entity: UserActionEntityType.Products,
                        scope: UserActionScopeType.Publication,
                        entityId: id
                    })
                );
            }
            this.isLoading = false;
        }
    }

    private async changeReferenceAvailability(reference: Reference): Promise<void> {
        const questionResult = await Swal.fire({
            title: reference.available ? this.$i18n.t('views.references.referencesListView.actions.makeUnavailable.modal.title').toString() : this.$i18n.t('views.references.referencesListView.actions.makeAvailable.modal.title').toString(),
            html: reference.available
                ? '<h3>' + reference.displayTitle + '</h3>' + this.$i18n.t('views.references.referencesListView.actions.makeUnavailable.modal.textHtml').toString()
                : '<h3>' + reference.displayTitle + '</h3>' + this.$i18n.t('views.references.referencesListView.actions.makeAvailable.modal.textHtml').toString(),
            type: 'warning',
            showCancelButton: true,
            reverseButtons: true,
            focusConfirm: true,
            focusCancel: false,
            confirmButtonText: this.$i18n.t(reference.available ? 'views.references.referencesListView.actions.makeUnavailable.modal.confirm.doConfirm' : 'views.references.referencesListView.actions.makeAvailable.modal.confirm.doConfirm').toString(),
            cancelButtonText: this.$i18n.t(reference.available ? 'views.references.referencesListView.actions.makeUnavailable.modal.doCancel' : 'views.references.referencesListView.actions.makeAvailable.modal.doCancel').toString(),
            customClass: {
                confirmButton: 'btn btn-primary',
                cancelButton: 'btn btn-danger'
            },
            animation: false
        });

        if (questionResult.value) {
            this.isLoading = true;
            if (await referencesService.setReferenceAvailability(reference.id, !reference.available)) {
                this.isLoading = false;
                notificationsService.showToastSuccessNotification(
                    reference.available ? 'views.references.referencesListView.actions.makeUnavailable.modal.confirm.successMessage' : 'views.references.referencesListView.actions.makeAvailable.modal.confirm.successMessage'
                );

                reference.available = !reference.available;

                await usersService.logUserAction(
                    new UserActionLogInfo({
                        type: UserActionType.HasChanged,
                        entity: UserActionEntityType.Products,
                        scope: UserActionScopeType.Availability,
                        entityId: reference.id
                    })
                );

                return;
            }
            this.isLoading = false;
            notificationsService.showToastErrorNotification();
        }
    }

    private availabilityClasses(row: any): string | null {
        let classes = row.isPublishedInAConsumer ? 'is-published' : 'not-published';
        classes = row.available ? classes + ' is-available' : classes + ' not-available';
        classes = row.hasBusinessAnActiveSalesAdmissionHoursSchedule ? classes + ' has-opening-hours-schedule' : classes + ' no-opening-hours-schedule';
        return classes;
    }

    private async changeReferenceTimeSensitivity(reference: Reference): Promise<void> {
        this.isLoading = true;
        if (await referencesService.setReferenceTimeSensitive(reference.id, !reference.isTimeSensitive)) {
            this.isLoading = false;
            reference.isTimeSensitive = !reference.isTimeSensitive;
            notificationsService.showToastSuccessNotification(reference.isTimeSensitive ? 'views.references.referencesListView.actions.makeTimeSensitive.successMessage' : 'views.references.referencesListView.actions.makeNotTimeSensitive.successMessage');

            await usersService.logUserAction(
                new UserActionLogInfo({
                    type: UserActionType.HasChanged,
                    entity: UserActionEntityType.Products,
                    scope: UserActionScopeType.TimeSensitivity,
                    entityId: reference.id
                })
            );

            return;
        }
        this.isLoading = false;
        notificationsService.showToastErrorNotification();
    }

    private async deleteReference(id: number, refName: string): Promise<void> {
        const questionResult = await Swal.fire({
            title: this.$i18n.t('views.references.referencesListView.actions.delete.modal.title').toString(),
            html: '<h3>' + refName + '</h3>' + this.$i18n.t('views.references.referencesListView.actions.delete.modal.textHtml').toString(),
            type: 'warning',
            showCancelButton: true,
            reverseButtons: true,
            focusConfirm: false,
            focusCancel: true,
            confirmButtonText: this.$i18n.t('views.references.referencesListView.actions.delete.modal.confirm.doConfirm').toString(),
            cancelButtonText: this.$i18n.t('views.references.referencesListView.actions.delete.modal.doCancel').toString(),
            customClass: {
                confirmButton: 'btn btn-primary',
                cancelButton: 'btn btn-danger'
            },
            animation: false
        });

        if (questionResult.value) {
            this.isLoading = true;
            if (await referencesService.deleteReference(id)) {
                this.isLoading = false;
                notificationsService.showToastSuccessNotification('views.references.referencesListView.actions.delete.modal.confirm.successMessage');
                await this.loadItems();

                await usersService.logUserAction(
                    new UserActionLogInfo({
                        type: UserActionType.HasDeleted,
                        entity: UserActionEntityType.Products,
                        scope: UserActionScopeType.Delete,
                        entityId: id
                    })
                );

                return;
            }
            this.isLoading = false;
            notificationsService.showToastErrorNotification();
        }
    }

    private async saveFiltersAndGoToReference(id: number): Promise<void> {
        localStorageService.saveReferencesListFilters(this.serverParams);
        this.$router.push(`/products/${id}`);
    }

    private columnFiltersChanged(newFilters: any): boolean {
        if (newFilters && this.serverParams && this.serverParams.columnFilters) {
            if (newFilters.displayTitle !== this.serverParams.columnFilters.displayTitle) {
                return true;
            }

            if (newFilters.categoryName !== this.serverParams.columnFilters.categoryName) {
                return true;
            }

            if ((authorizationManagerService.isAdmin || authorizationManagerService.canReadMultipleBusinesses) && newFilters.businessTradeName !== this.serverParams.columnFilters.businessTradeName) {
                return true;
            }
        }

        return false;
    }

    private initPaging() {
        const savedFilters = localStorageService.getReferencesListFilters();
        if (savedFilters) {
            this.initialPage = savedFilters.page;
            this.initialRefsPerPage = savedFilters.perPage;
        }
    }

    // #region EDIT STOCK LEVELS

    private editStockLevels(reference: Reference): void {
        this.selectedReference = reference;
        this.rowsCopy = this.rows.map(r => r.clone());
        this.showEditStockLevels = true;
    }

    private async saveReferenceStockLevels(reference: Reference): Promise<void> {
        this.savingStockLevels = true;

        try {
            const updateResult = await referencesService.updateReferenceSkus(reference.id!, reference.skus);
            if (updateResult) {
                this.showEditStockLevels = false;
                notificationsService.showToastSuccessNotification('views.references.referencesListView.editStockLevels.save.successMessage');
                await this.loadItems();

                await usersService.logUserAction(
                    new UserActionLogInfo({
                        type: UserActionType.HasChanged,
                        entity: UserActionEntityType.Products,
                        scope: UserActionScopeType.Stock,
                        entityId: reference.id
                    })
                );

                return;
            }
            notificationsService.showToastErrorNotification();
        } catch {
            notificationsService.showToastErrorNotification();
        } finally {
            this.savingStockLevels = false;
        }
    }

    private closeReferenceStockLevelsEdition(): void {
        this.rows = this.rowsCopy;
        this.showEditStockLevels = false;
    }

    // #endregion EDIT STOCK LEVELS

    private async copyToClipboard(text: string): Promise<void> {
        await navigator.clipboard.writeText(text);
        notificationsService.showToastInfoNotification('views.references.referencesListView.actions.copyToClipboard.successMessage');
    }

    private async cloneOrganizationReference(id: number, refName: string): Promise<void> {
        const cloneOrganizationReferenceInputDto: CloneOrganizationReferenceInputDto = new CloneOrganizationReferenceInputDto(id);
        const questionResult = await Swal.fire({
            title: this.$i18n.t('views.references.referencesListView.actions.clone.modal.title').toString(),
            html: '<h3>' + refName + '</h3>' + this.$i18n.t('views.references.referencesListView.actions.clone.modal.textHtml').toString(),
            type: 'warning',
            showCancelButton: true,
            reverseButtons: true,
            focusConfirm: false,
            focusCancel: true,
            confirmButtonText: this.$i18n.t('views.references.referencesListView.actions.clone.modal.confirm.doConfirm').toString(),
            cancelButtonText: this.$i18n.t('views.references.referencesListView.actions.clone.modal.doCancel').toString(),
            customClass: {
                confirmButton: 'btn btn-primary',
                cancelButton: 'btn btn-danger'
            },
            animation: false
        });

        if (questionResult.value) {
            this.isLoading = true;
            try {
                await cloneOrganizationReference.execute(cloneOrganizationReferenceInputDto);

                notificationsService.showToastSuccessNotification('views.references.referencesListView.actions.clone.modal.confirm.successMessage');

                await authorizationManagerService.refreshPermissions();

                await this.loadItems();

                await usersService.logUserAction(
                    new UserActionLogInfo({
                        type: UserActionType.HasCloned,
                        entity: UserActionEntityType.Products,
                        scope: UserActionScopeType.Clone,
                        entityId: id
                    })
                );
            } catch {
                notificationsService.showToastErrorNotification();
            } finally {
                this.isLoading = false;
            }
        }
    }
}
